import { createSignal, Show, type JSX } from 'solid-js';
import Navbar from '../components/Navbar';
import TopNavLinks from '../components/TopNavLinks';
import Footer from '../components/Footer';

export default function NavbarLayout(props: { children: JSX.Element }) {
  const [menuOpen, setMenuOpen] = createSignal(false);
  const close = () => setMenuOpen(false);
  const toggle = () => setMenuOpen(prev => !prev);

  const hamburger = (
    <button class="hamburger-btn" onClick={toggle} aria-label="Toggle menu">
      <i class="fa-solid fa-bars"></i>
    </button>
  );

  return (
    <>
      <Navbar menuButton={hamburger}>
        <div style={{ display: 'flex', 'flex-direction': 'column', width: '100%', 'min-height': 'calc(100vh - 56px)' }}>
          <div style={{ flex: '1 0 auto' }}>{props.children}</div>
          <Footer />
        </div>
      </Navbar>
      <Show when={menuOpen()}>
        <div class="mobile-menu-backdrop" onClick={close} />
        <div class="mobile-menu-dropdown">
          <TopNavLinks onNavigate={close} includeAuth />
        </div>
      </Show>
    </>
  );
}
